import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { PaneHeader } from "@/components/settings/frame";
import { LanguagePicker } from "@/components/shell/language-picker";

export const Route = createFileRoute("/settings/language")({
  component: LanguagePage,
});

function LanguagePage() {
  const { t } = useTranslation("settings");
  return (
    <div>
      <PaneHeader title={t("nav.language")} description={`${t("language.hint")} ${t("language.ownWords")}`} />
      <LanguagePicker className="max-w-md border-t border-line-strong pt-6" />
    </div>
  );
}
